<template>
    <div class="radio-group-wrapper">
        <div
            class="radio"
            v-for="(item, index) in items"
            :key="index"
            @click="selectItem(item, index)"
        >
            <div class="bullet" :class="{ active: index === activeRadio }">
                <div class="circle" v-if="index === activeRadio"></div>
            </div>
            <div class="value">{{ itemKey ? item[itemKey] : item }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RadioGroup',
    data: () => ({
        activeRadio: null,
    }),
    props: {
        items: Array,
        itemKey: String,
        itemValue: String,
        returnObject: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        selectItem(item, index) {
            this.activeRadio = index;
            if (this.itemValue) {
                this.$emit('change', item[this.itemValue]);
            } else {
                this.$emit('change', item);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    .radio-group-wrapper{
        .radio{
            cursor: pointer;
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-bottom: 16px;

            .bullet{
                width: 20px;
                height: 20px;
                background: #FFFFFF;
                border: 2px solid #98A0A9;
                box-sizing: border-box;
                border-radius: 50%;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                .circle{
                    width: 8px;
                    height: 8px;
                    background: white;
                    border-radius: 50%;
                }
            }
            .active {
                background: #4663AB;
                border: 2px solid #4663AB;
                box-sizing: border-box;
                border-radius: 50%;
            }
            .value{
                margin-left: 12px;
                font-style: normal;
                font-weight: normal;
                font-size: 16px;
                line-height: 24px;
                color: #2A2626;
            }
        }
    }
</style>